import { BASIN_SESSION_ID, INSCALAR_SESSION_ID } from '@constants/cookieNames'
import Cookies from 'js-cookie'

export const getSessionId = (): string | undefined =>
    Cookies.get(INSCALAR_SESSION_ID) ?? Cookies.get(BASIN_SESSION_ID)

export default getSessionId
